/**
 * Static-translations for id. Generated from:
 *  - `online/lang/static-translations.ts` (legacy, via KEY_MAP)
 *  - `tools/sdk-translations.mjs` (SDK-specific strings)
 *
 * Do not edit by hand — changes are lost on the next `node tools/gen-locales.mjs`.
 * To fix a translation, edit legacy/sdk-translations.mjs and regenerate.
 */
const id = {
  'anon.heading_default': 'Lanjutkan sebagai tamu',
  'anon.try_again': 'Coba lagi',
  'auth.back_to_login': 'Kembali ke login',
  'auth.check_email_message': 'Periksa email Anda untuk kode konfirmasi.',
  'auth.check_email_title': 'Periksa email Anda',
  'auth.confirm_email_title': 'Konfirmasi email Anda',
  'auth.confirmation_code': 'Kode konfirmasi',
  'auth.continue_with_apple': 'Lanjutkan dengan Apple',
  'auth.continue_with_facebook': 'Lanjutkan dengan Facebook',
  'auth.continue_with_github': 'Lanjutkan dengan GitHub',
  'auth.continue_with_google': 'Lanjutkan dengan Google',
  'auth.create_account': 'Buat akun',
  'auth.default_subtitle': 'Masuk untuk mengakses semua fitur dan menyinkronkan data Anda.',
  'auth.email': 'Alamat email',
  'auth.email_already_registered': 'Email ini sudah terdaftar. Masuk di bawah dengan kata sandi atau akun yang Anda gunakan saat mendaftar.',
  'auth.email_exists': 'Akun dengan email ini sudah ada.',
  'auth.email_not_confirmed': 'Konfirmasi email Anda terlebih dahulu.',
  'auth.forgot_password': 'Lupa kata sandi?',
  'auth.forgot_password_title': 'Lupa kata sandi?',
  'auth.forgot_subtitle': 'Masukkan email Anda dan kami akan mengirimkan tautan reset kata sandi.',
  'auth.generic_error': 'Terjadi kesalahan',
  'auth.have_account': 'Sudah punya akun?',
  'auth.hide_password': 'Sembunyikan kata sandi',
  'auth.identity_already_linked': 'Akun ini sudah terdaftar. Masuk dengan akun ini di bawah.',
  'auth.invalid_credentials': 'Email atau kata sandi salah',
  'auth.invalid_otp': 'Kode tidak valid atau kedaluwarsa.',
  'auth.last_used': 'Terakhir dipakai · {email}',
  'auth.last_used_no_email': 'Terakhir dipakai',
  'auth.link_purchase_subheading': 'Kami akan menautkan pembelian ke akun Anda agar akses tetap terjaga.',
  'auth.log_in': 'Masuk',
  'auth.log_in_link': 'Masuk',
  'auth.login_continue_purchase': 'Masuk untuk melanjutkan pembelian Anda',
  'auth.network_error': 'Kesalahan jaringan. Periksa koneksi Anda dan coba lagi.',
  'auth.no_account': 'Belum punya akun?',
  'auth.or': 'atau',
  'auth.password': 'Kata sandi',
  'auth.passwords_mismatch': 'Kata sandi tidak cocok',
  'auth.rate_limited': 'Terlalu banyak permintaan. Coba lagi nanti.',
  'auth.repeat_password': 'Ulangi kata sandi',
  'auth.reset_link_valid': 'Tautan berlaku selama 1 jam.',
  'auth.reset_password_title': 'Atur ulang kata sandi',
  'auth.reset_sent_message': 'Jika email tersebut ada, kode reset telah dikirim.',
  'auth.reset_sent_subtitle': 'Kami telah mengirim tautan reset kata sandi. Ikuti petunjuk di email.',
  'auth.restore_purchases_heading': 'Pulihkan pembelian',
  'auth.restore_purchases_subheading': 'Silakan masuk untuk memulihkan pembelian Anda.',
  'auth.send_reset': 'Kirim email reset',
  'auth.service_unavailable': 'Layanan sementara tidak tersedia. Coba lagi nanti.',
  'auth.show_password': 'Tampilkan kata sandi',
  'auth.sign_out': 'Keluar',
  'auth.sign_up': 'Daftar',
  'auth.sign_up_link': 'Daftar',
  'auth.signed_in': 'Masuk',
  'auth.signin_failed': 'Masuk gagal',
  'auth.signup_failed': 'Pendaftaran gagal',
  'auth.verify': 'Verifikasi',
  'auth.weak_password': 'Kata sandi terlalu lemah.',
  'auth.welcome': 'Selamat datang!',
  'auth.welcome_signup': 'Selamat datang!',
  'cta.close': 'Tutup',
  'cta.continue': 'Lanjutkan',
  'cta.get_lifetime_access': 'Dapatkan akses seumur hidup',
  'cta.get_plan_daily': 'Dapatkan paket harian',
  'cta.get_plan_monthly': 'Dapatkan paket bulanan',
  'cta.get_plan_weekly': 'Dapatkan paket mingguan',
  'cta.get_plan_yearly': 'Dapatkan paket tahunan',
  'cta.start_trial': 'Mulai uji coba gratis {days} hari',
  'modal.close_aria': 'Tutup',
  'modal.continue': 'Lanjutkan',
  'modal.error_generic': 'Terjadi kesalahan',
  'modal.loading': 'Memuat…',
  'modal.purchase_restored_subtitle': 'Semua siap — selamat menikmati!',
  'modal.purchase_restored_title': 'Selamat datang kembali',
  'modal.purchase_success_subtitle': 'Semua siap — selamat menikmati!',
  'modal.purchase_success_title': 'Pembayaran diterima',
  'modal.verifying_subscription': 'Memeriksa langganan Anda…',
  'nav.back': '← Kembali',
  'nav.back_aria': 'Kembali',
  'offer.limited_time': 'Penawaran terbatas',
  'payment.awaiting_title': 'Selesaikan pembayaran di tab baru',
  'payment.checking': 'Memeriksa…',
  'payment.ive_paid': 'Saya sudah membayar',
  'payment.open_checkout_again': 'Buka pembayaran lagi',
  'payment.open_checkout_button': 'Buka pembayaran',
  'pricing.free_trial_days': 'Uji coba gratis {days} hari',
  'pricing.included_per': 'Termasuk per {interval}:',
  'pricing.interval.day': 'hari',
  'pricing.interval.lifetime_short': 'seumur hidup',
  'pricing.interval.month': 'bulan',
  'pricing.interval.period': 'periode',
  'pricing.interval.week': 'minggu',
  'pricing.interval.year': 'tahun',
  'pricing.money_back': 'Jaminan uang kembali 30 hari',
  'pricing.most_popular': 'Paling populer',
  'pricing.no_prices': 'Tidak ada harga tersedia.',
  'pricing.plan_label.daily': 'PAKET HARIAN',
  'pricing.plan_label.lifetime': 'seumur hidup',
  'pricing.plan_label.monthly': 'paket bulanan',
  'pricing.plan_label.weekly': 'paket mingguan',
  'pricing.plan_label.yearly': 'paket tahunan',
  'pricing.plans_aria': 'Paket',
  'session.contact_support': 'Hubungi dukungan',
  'session.restore_purchases': 'Pulihkan pembelian',
  'session.sign_out': 'Keluar',
  'session.signed_in_as_prefix': 'Masuk sebagai',
  'session.signing_out': 'Keluar…',
  'support.attachments_label': 'Lampiran',
  'support.close_button': 'Tutup',
  'support.done_button': 'Selesai',
  'support.email_placeholder': 'Masukkan email Anda',
  'support.heading': 'Dukungan',
  'support.instruction': 'Silakan isi formulir di bawah ini untuk mengirimkan permintaan dukungan Anda.',
  'support.invalid_email': 'Email tidak valid',
  'support.message_length': '1–5000 karakter',
  'support.message_placeholder': 'Masukkan pesan Anda',
  'support.required': 'Wajib',
  'support.send_another': 'Kirim permintaan lain',
  'support.send_button': 'Kirim',
  'support.sending': 'Mengirim…',
  'support.subject_length': '3–200 karakter',
  'support.subject_placeholder': 'Masukkan subjek Anda',
  'support.success_heading': 'Permintaan terkirim',
  'support.success_message_prefix': 'Kami telah menerima pesan Anda dan akan merespons ke'
} as const;

export default id;
